// extracted by mini-css-extract-plugin
export var blockedMessage = "_b0-3";
export var blockedOverlay = "_b0-1";
export var fadeIn = "_b0-2";
export var hereLink = "_b0-0";
export var slideUp = "_b0-4";